import { navigateTo } from '../router.js';

const NAV_LINKS = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Lab', path: '/trading-lab' },
  { label: 'Dashboard', path: '/dashboard' },
  { label: 'Strategies', path: '/strategies' },
  { label: 'Backtests', path: '/backtests' },
  { label: 'Risk Engine', path: '/risk-engine' },
  { label: 'Dev Center', path: '/dev-center' },
  { label: 'Docs', path: '/docs' },
  { label: 'Releases', path: '/releases' },
  { label: 'Store', path: '/store' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

let currentMode = 'PRODUCT';

export function initNav(): void {
  const root = document.getElementById('nav-root');
  if (!root) return;

  root.innerHTML = renderNav();
  attachNavEvents(root);
  updateActiveLink();
}

function renderNav(): string {
  const linksHTML = NAV_LINKS.map(link =>
    `<span class="nav-link" data-path="${link.path}">${link.label}</span>`
  ).join('');

  return `
    <nav class="nav">
      <span class="nav-logo" data-path="/">⬡ HEDGEFUN.DEV</span>
      <div class="nav-links">${linksHTML}</div>
      <div class="nav-mode-pill">
        <button class="nav-mode-btn ${currentMode === 'PRODUCT' ? 'active' : ''}" data-mode="PRODUCT">PRODUCT</button>
        <button class="nav-mode-btn ${currentMode === 'SIMULATION' ? 'active' : ''}" data-mode="SIMULATION">SIM</button>
        <button class="nav-mode-btn ${currentMode === 'DEVELOPER' ? 'active' : ''}" data-mode="DEVELOPER">DEV</button>
      </div>
      <button class="nav-hamburger" id="nav-hamburger" aria-label="Menu">
        <span></span><span></span><span></span>
      </button>
    </nav>
    <div class="nav-mobile-menu" id="nav-mobile-menu">
      ${NAV_LINKS.map(l => `<span class="nav-link" data-path="${l.path}">${l.label}</span>`).join('')}
    </div>
  `;
}

function attachNavEvents(root: HTMLElement): void {
  // Logo click
  root.querySelectorAll('[data-path]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const path = (el as HTMLElement).dataset['path'];
      if (path) {
        navigateTo(path);
        closeMobileMenu(root);
        updateActiveLink();
      }
    });
  });

  // Mode buttons
  root.querySelectorAll('.nav-mode-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      currentMode = (btn as HTMLElement).dataset['mode'] ?? 'PRODUCT';
      root.querySelectorAll('.nav-mode-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // Hamburger
  const hamburger = document.getElementById('nav-hamburger');
  const mobileMenu = document.getElementById('nav-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
    });
  }

  // Listen to route changes
  window.addEventListener('hashchange', () => updateActiveLink());
}

function updateActiveLink(): void {
  const hash = window.location.hash.replace('#', '') || '/';
  document.querySelectorAll('.nav-link').forEach(el => {
    const path = (el as HTMLElement).dataset['path'];
    if (path === hash || (hash === '/' && path === '/')) {
      el.classList.add('active');
    } else {
      el.classList.remove('active');
    }
  });
}

function closeMobileMenu(root: HTMLElement): void {
  const hamburger = root.querySelector('#nav-hamburger');
  const mobileMenu = root.querySelector('#nav-mobile-menu');
  hamburger?.classList.remove('open');
  mobileMenu?.classList.remove('open');
}
